export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Share"])},
        "location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Location"])},
        "personal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Personal"])},
        "destination": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destination"])},
        "share": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Share"])}
      },
      "fr": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partager"])},
        "location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Emplacement"])},
        "personal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Personnel"])},
        "destination": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destination"])},
        "share": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partager"])}
      }
    }
  })
}